// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__6d+rg","header":"tooltip_header__Ibe3e","body":"tooltip_body__V70j9"};